enum AccessReportsWizardAnalysisTypeEnum {
  Standard = 0,
  DynamicByZipClass = 1,
  DynamicByCountyClass = 2,
}

export { AccessReportsWizardAnalysisTypeEnum };
